import { gql } from '@apollo/client/core';

export const getFacilities = gql`
  query getFacilities($lastCacheUpdate: String) {
    getFacilities(lastCacheUpdate: $lastCacheUpdate) {
      id
      ContactListId
      Locations {
        id
        state
        county
        township
      }
      businessUnit {
        id
        name
      }
      address
      facilityName
      facilityUid
      facilityType
      FacilityType {
        id
        name
      }
      AORs {
        id
        name
        isPrimary
      }
      Company {
        id
        name
      }
      notes
      phone
      gps
      scadaId
      flocNumber
      timezone
      updater
      deletedAt
      version
      hidden
      # AdditionalResourceLists {
      #   id
      #   name
      #   ContactListMembers {
      #     id
      #     order
      #     Contact {
      #       id
      #       firstName
      #       lastName
      #       nickName
      #       adAccountName
      #       otherPhone
      #       speedDial
      #       businessMobile
      #       businessPhone
      #       afterHoursPhoneNumber
      #       home
      #       other
      #       personalMobile
      #       Company {
      #         id
      #         name
      #         abbreviation
      #         version
      #       }
      #       WhenUnavailable {
      #         id
      #         firstName
      #         lastName
      #       }
      #       JobRole {
      #         id
      #         name
      #       }
      #       ReportsTo {
      #         id
      #         firstName
      #         lastName
      #         businessMobile
      #         ReportsTo {
      #           id
      #           firstName
      #           lastName
      #           businessMobile
      #         }
      #         version
      #       }
      #     }
      #   }
      #   AdditionalResourceListType {
      #     id
      #     name
      #     enabled
      #   }
      # }
    }
  }
`;
